import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import ItemsController from "@/modules/items/ItemsController";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

/**
 * Items page. Renders the items list, gated behind the `items.view`
 * permission with a full-page access denied state otherwise. Edit controls
 * are additionally gated on `items.edit`.
 * @returns The Items page, or an access denied state when unauthorized
 */
export default function Items() {
  const canView = useHasPermission(Permission.ITEMS_VIEW);
  const canEdit = useHasPermission(Permission.ITEMS_EDIT);

  const breadcrumbs = [{ label: "Items", current: true }];

  if (!canView) {
    return <AccessRestricted breadcrumbs={breadcrumbs} />;
  }

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <ItemsController canEdit={canEdit} />
    </Layout>
  );
}
